import { render, staticRenderFns } from "./MemberReports.vue?vue&type=template&id=489029f8&scoped=true&"
import script from "./MemberReports.vue?vue&type=script&lang=js&"
export * from "./MemberReports.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "489029f8",
  null
  
)

export default component.exports